import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Checklist,
  Drawer,
  FileField,
  Input,
  Field
} from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const EditConfigField = ({ field, onClose, onSave, show }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const {
      group,
      label,
      text_default,
      textarea_default,
      integer_default,
      decimal_precision,
      decimal_default,
      boolean_default,
      array_options,
      array_defaults,
      field_type
    } = field || {};

    setData({
      group,
      label,
      text_default,
      textarea_default,
      integer_default,
      decimal_precision,
      decimal_default,
      boolean_default,
      array_options,
      array_defaults,
      field_type
    });
  }, [field]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handleFileChange = (name, file) => {
    setData({ ...data, [name]: file });
  };

  const save = () => {
    Api.updateConfigField(field.guid, data).then(() => {
      onSave();
      setData({});
    });
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={save}>Save</Button>}
      onClose={onClose}
      show={show}
      title='Edit Config Field'
    >
      <Field label='Group'>
        <Input onChange={handleInputChange.bind(null, 'group')} value={data.group || ''} />
      </Field>
      <Field label='Label'>
        <Input onChange={handleInputChange.bind(null, 'label')} value={data.label || ''} />
      </Field>
      <Field label='Default Value'>
        {data.field_type === 'text' ? (
          <Input
            onChange={handleInputChange.bind(null, 'text_default')}
            value={data.text_default || ''}
          />
        ) : null}

        {data.field_type === 'textarea' ? (
          <Input
            height={120}
            onChange={handleInputChange.bind(null, 'textarea_default')}
            type='textarea'
            value={data.textarea_default || ''}
          />
        ) : null}

        {data.field_type === 'integer' ? (
          <Input
            onChange={handleInputChange.bind(null, 'integer_default')}
            step={1}
            type='number'
            value={data.integer_default || ''}
          />
        ) : null}

        {data.field_type === 'decimal' ? (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Input
              onChange={handleInputChange.bind(null, 'decimal_precision')}
              step={1}
              style={{ width: '49%' }}
              type='number'
              value={data.decimal_precision || ''}
            />
            <Input
              onChange={handleInputChange.bind(null, 'decimal_default')}
              style={{ width: '49%' }}
              type='number'
              value={data.decimal_default || ''}
            />
          </div>
        ) : null}

        {data.field_type === 'boolean' ? (
          <Checkbox
            checked={data.boolean_default}
            label='Boolean Default Value'
            onChange={handleCheckboxChange.bind(null, 'boolean_default')}
          />
        ) : null}

        {data.field_type === 'array' ? (
          <Checklist
            onChange={handleChecklistChange.bind(null, 'array_defaults')}
            options={data.array_options.map(o => ({ value: o }))}
            selected={data.array_defaults}
          />
        ) : null}

        {data.field_type === 'file' ? (
          <FileField
            file={data.file_default}
            fileUrl={field && field.file_default ? field.file_default.url : ''}
            onChange={handleFileChange.bind(null, 'file_default')}
          />
        ) : null}
      </Field>
    </Drawer>
  );
};

EditConfigField.propTypes = {
  field: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default EditConfigField;
